import api from '../axios'
import type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
  ChangePasswordRequest,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  MessageResponse,
  User,
  TokenVerificationResponse,
} from '@/interface/auth'

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post('/auth/token', data)
    return response.data
  },

  register: async (data: RegisterRequest): Promise<RegisterResponse> => {
    const response = await api.post('/auth/register', data)
    return response.data
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await api.get('/auth/me')
    return response.data
  },

  changePassword: async (data: ChangePasswordRequest): Promise<MessageResponse> => {
    const response = await api.post('/auth/change-password', data)
    return response.data
  },

  forgotPassword: async (data: ForgotPasswordRequest): Promise<MessageResponse> => {
    const response = await api.post('/auth/forgot-password', data)
    return response.data
  },

  resetPassword: async (data: ResetPasswordRequest): Promise<MessageResponse> => {
    const response = await api.post('/auth/reset-password', data)
    return response.data
  },

  verifyToken: async (): Promise<TokenVerificationResponse> => {
    const response = await api.get('/auth/verify')
    return response.data
  },

  // Admin only endpoints
  createUser: async (data: any): Promise<void> => {
    await api.post('/auth/users', data)
  },

  // User management endpoints
  getAllUsers: async (): Promise<any[]> => {
    const response = await api.get('/users')
    return response.data
  },

  getUserById: async (id: string): Promise<any> => {
    const response = await api.get(`/users/${id}`)
    return response.data
  },

  updateUser: async (id: string, data: any): Promise<any> => {
    const response = await api.patch(`/users/${id}`, data)
    return response.data
  },

  deleteUser: async (id: string): Promise<void> => {
    await api.delete(`/users/${id}`)
  },
}
